export const newsTexts = (state) => state.newsTexts;
export const isNewsTextActive = (state) => state.newsTexts.length > 0;
